
const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];


export const convertDigitToEnglish = (str) => {
    if (typeof (str) === 'string') {
        for (var i = 0; i < 10; i++) {
            str = str.replace(persianNumbers[i], i).replace(arabicNumbers[i], i);
        }
    }
    return str;
};

 export function toPersianNum(num) {
    let str = num
    str = str.replaceAll("1", "۱");
    str = str.replaceAll("2", "۲");
    str = str.replaceAll("3", "۳");
    str = str.replaceAll("4", "۴");
    str = str.replaceAll("5", "۵");
    str = str.replaceAll("6", "۶");
    str = str.replaceAll("7", "۷");
    str = str.replaceAll("8", "۸");
    str = str.replaceAll("9", "۹");
    str = str.replaceAll("0", "۰");
    return str;
  }
